import { KzIcon } from '../generated-icons/kz-icon.model';
import { kzIconsKaza } from '../generated-icons/kzIcons-kaza.icon';
import { kzIconsBath } from '../generated-icons/kzIcons-bath.icon';
import { kzIconsCauldron } from '../generated-icons/kzIcons-cauldron.icon';
import { kzIconsShower } from '../generated-icons/kzIcons-shower.icon';
import { kzIconsWc } from '../generated-icons/kzIcons-wc.icon';
import { kzIconsWashingMachine } from '../generated-icons/kzIcons-washing-machine.icon';

export const kazaplanIcons: KzIcon[] = [
  kzIconsKaza,
  kzIconsBath,
  kzIconsCauldron,
  kzIconsShower,
  kzIconsWc,
  kzIconsWashingMachine,
];
